import { type ComponentType, lazy } from 'react';

// Lazy, unlike the other discovery globs: eager would put every contribution back on the critical path.
const modules = import.meta.glob<{ default: ComponentType }>('./*/shell.manifest.tsx');

export const shellContributions: ReadonlyArray<readonly [path: string, Component: ComponentType]> = Object.entries(modules)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([path, load]) => [path, lazy(load)] as const);
